/* ============================================================
   valtor.js: JavaScript do tema VALTOR (sem dependencias)
   ------------------------------------------------------------
   Configuracao: window.valtor (definida em layout/theme.liquid).
   Blocos:
   1. Utilidades e toast
   2. Overlays (carrinho, menu do celular, busca, popup)
   3. Carrinho AJAX (adicionar, trocar quantidade, atualizar a gaveta)
   4. Busca com sugestoes
   5. Abas ("Explorar a loja")
   6. Colecao: filtros, ordenacao e uma cor por modelo
   7. Produto: galeria, zoom, gravacao, entrega estimada, adicionar ao carrinho
   8. Revelar ao rolar e cabecalho fixo
   O tema nao usa prefers-reduced-motion por decisao do Gabriel.
   ============================================================ */
(function () {
  'use strict';

  var V = window.valtor || {};
  var R = V.routes || {};
  var S = V.strings || {};

  /* ---------- 1. utilidades ---------- */
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function money(amount) {
    var n = Number(amount) || 0;
    try {
      return new Intl.NumberFormat(V.locale || 'en', { style: 'currency', currency: V.currency || 'USD', minimumFractionDigits: n % 1 === 0 ? 0 : 2 }).format(n);
    } catch (e) { return '$' + n.toFixed(2); }
  }

  var toastTimer;
  function toast(msg) {
    var t = $('#Toast');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.classList.remove('on'); }, 3400);
  }
  V.toast = toast;

  /* ---------- 2. overlays ---------- */
  var lastFocus = null;
  function overlay(name) { return $('[data-overlay="' + name + '"]'); }
  function openCls(name) { return name === 'popup' ? 'on' : 'open'; }

  function openOverlay(name) {
    var el = overlay(name);
    if (!el) return;
    lastFocus = document.activeElement;
    el.classList.add(openCls(name));
    el.setAttribute('aria-hidden', 'false');
    if (name === 'cart') { var sc = $('[data-scrim]'); if (sc) sc.classList.add('on'); }
    document.body.style.overflow = 'hidden';
    var focusEl = $('[data-close]', el) || $('input', el);
    if (name === 'search') focusEl = $('[data-search-input]', el);
    if (focusEl && focusEl.focus) setTimeout(function () { focusEl.focus(); }, 60);
  }

  function closeOverlay(name, keepFocus) {
    var el = overlay(name);
    if (!el) return;
    el.classList.remove('open', 'on');
    el.setAttribute('aria-hidden', 'true');
    if (name === 'cart') { var sc = $('[data-scrim]'); if (sc) sc.classList.remove('on'); }
    if (!$('[data-overlay].open, [data-overlay].on')) document.body.style.overflow = '';
    if (name === 'popup') { try { localStorage.setItem('valtor-popup', '1'); } catch (e) { } }
    if (!keepFocus && lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function closeAll() {
    $$('[data-overlay]').forEach(function (el) { closeOverlay(el.getAttribute('data-overlay'), true); });
  }

  /* menus de filtro da colecao: fecha e zera o aria-expanded */
  function closeFilters() {
    $$('.fdd.open').forEach(function (d) {
      d.classList.remove('open');
      var b = $('.fbtn', d); if (b) b.setAttribute('aria-expanded', 'false');
    });
  }

  /* lightbox da foto do produto: fecha e devolve o foco a quem abriu */
  var lbOpener = null;
  function closeLightbox() {
    var lb = $('.lightbox.on');
    if (!lb) return;
    lb.classList.remove('on');
    lb.setAttribute('aria-hidden', 'true');
    if (lbOpener && lbOpener.focus) lbOpener.focus();
    lbOpener = null;
  }

  document.addEventListener('click', function (e) {
    var op = e.target.closest('[data-open]');
    if (op) {
      var name = op.getAttribute('data-open');
      if (name === 'cart' && !overlay('cart')) return; /* sem gaveta: segue o link para /cart */
      e.preventDefault();
      if (name === 'cart') refreshCart(true); else openOverlay(name);
      return;
    }
    var cl = e.target.closest('[data-close]');
    if (cl) { e.preventDefault(); closeOverlay(cl.getAttribute('data-close')); return; }
    if (e.target.closest('[data-scrim]')) { closeOverlay('cart'); return; }
    if (!e.target.closest('.fdd')) closeFilters();
  });

  document.addEventListener('keydown', function (e) {
    /* com o zoom aberto o unico item focavel e o botao de fechar: o Tab nao sai do dialogo */
    if (e.key === 'Tab' && $('.lightbox.on')) { e.preventDefault(); var cb = $('.lightbox.on button'); if (cb) cb.focus(); return; }
    if (e.key !== 'Escape') return;
    var any = $('[data-overlay].open, [data-overlay].on');
    if (any) closeOverlay(any.getAttribute('data-overlay'));
    closeFilters();
    closeLightbox();
  });

  /* ---------- 3. carrinho AJAX ---------- */
  function updateCount() {
    return fetch(R.cartJs, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count > 0 ? cart.item_count : ''; });
        return cart;
      });
  }

  /* Busca o HTML novo da gaveta (Section Rendering API) e troca o conteudo. */
  function refreshCart(openAfter) {
    var url = (R.root || '/') + '?sections=cart-drawer';
    return fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['cart-drawer'];
        if (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = $('#CartDrawer', doc);
          var cur = $('#CartDrawer');
          if (fresh && cur) cur.innerHTML = fresh.innerHTML;
        }
        return updateCount();
      })
      .then(function () { if (openAfter) openOverlay('cart'); })
      .catch(function () { toast(S.cartError); });
  }

  function addToCart(formData) {
    return fetch(R.cartAdd, { method: 'POST', body: formData, headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok) { toast(res.body.description || S.cartError); return false; }
        return refreshCart(true).then(function () { return true; });
      })
      .catch(function () { toast(S.cartError); return false; });
  }

  document.addEventListener('click', function (e) {
    var q = e.target.closest('[data-qty-change]');
    if (q) {
      e.preventDefault();
      fetch(R.cartChange, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: Number(q.getAttribute('data-qty-change')), quantity: Number(q.getAttribute('data-qty-value')) })
      }).then(function () { return refreshCart(false); }).catch(function () { toast(S.cartError); });
      return;
    }
    var qa = e.target.closest('[data-quick-add]');
    if (qa) {
      e.preventDefault();
      var fd = new FormData();
      fd.append('id', qa.getAttribute('data-quick-add'));
      fd.append('quantity', '1');
      qa.disabled = true;
      addToCart(fd).then(function () { qa.disabled = false; });
    }
  });

  /* ---------- 4. busca com sugestoes ---------- */
  function initSearch() {
    var input = $('[data-search-input]');
    var box = $('[data-search-results]');
    if (!input || !box || input.getAttribute('data-ready')) return;
    input.setAttribute('data-ready', '1');
    var timer, last = '';
    input.addEventListener('input', function () {
      clearTimeout(timer);
      var term = input.value.trim();
      if (term === last) return;
      last = term;
      if (term.length < 2) { box.innerHTML = ''; return; }
      timer = setTimeout(function () {
        var url = R.suggest + '.json?q=' + encodeURIComponent(term) + '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last';
        fetch(url, { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            if (term !== input.value.trim()) return;
            var items = (data.resources && data.resources.results && data.resources.results.products) || [];
            if (!items.length) { box.innerHTML = '<div class="none">' + esc((S.noResults || '').replace('__TERMS__', term)) + '</div>'; return; }
            box.innerHTML = items.map(function (p) {
              var img = p.featured_image && p.featured_image.url ? '<img src="' + esc(p.featured_image.url) + '" alt="" loading="lazy" width="64" height="64">' : '';
              return '<a href="' + esc(p.url) + '"><div class="th">' + img + '</div><div><b>' + esc(p.title) + '</b><span>' + esc(p.type || '') + '</span></div><span>' + money(p.price) + '</span></a>';
            }).join('') + '<a class="all" href="' + esc(R.search + '?q=' + encodeURIComponent(term) + '&type=product') + '">' + esc('View all results') + '</a>';
          })
          .catch(function () { box.innerHTML = ''; });
      }, 220);
    });
  }

  /* ---------- 5. abas ---------- */
  function initTabs() {
    $$('[data-tabs]').forEach(function (root) {
      if (root.getAttribute('data-ready')) return;
      root.setAttribute('data-ready', '1');
      var tabs = $$('[role="tab"]', root);
      var panels = $$('[data-tab-panel]', root.parentNode);
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var id = tab.getAttribute('data-tab');
          tabs.forEach(function (t) { t.setAttribute('aria-selected', t === tab ? 'true' : 'false'); });
          panels.forEach(function (p) { p.hidden = p.getAttribute('data-tab-panel') !== id; });
        });
      });
    });
  }

  /* ---------- 6. colecao: filtros, ordenacao, uma cor por modelo ---------- */
  var FILTER_KEYS = ['style', 'case', 'dial', 'band', 'movement'];
  var FILTER_LABEL = { style: 'Style', case: 'Case', dial: 'Dial', band: 'Band', movement: 'Movement' };

  function cap(s) { s = String(s).replace(/-/g, ' '); return s.charAt(0).toUpperCase() + s.slice(1); }

  function initCollection() {
    var root = $('[data-collection]');
    if (!root || root.getAttribute('data-ready')) return;
    root.setAttribute('data-ready', '1');

    var grid = $('[data-grid]', root);
    var cards = $$('[data-card]', grid);
    cards.forEach(function (c, i) { c.setAttribute('data-index', i); });

    var params = new URLSearchParams(location.search);
    var state = { sort: params.get('sort') || 'featured', min: params.get('min'), max: params.get('max'), gift: params.get('gift') };
    FILTER_KEYS.forEach(function (k) { state[k] = params.get(k) ? params.get(k).split(',').filter(Boolean) : []; });

    var countEl = $('[data-count]', root);
    var activeEl = $('[data-active]', root);
    var emptyEl = $('[data-empty]', root);
    var sortEl = $('[data-sort]', root);
    var titleEl = $('[data-collection-title]');
    var subEl = $('[data-collection-sub]');
    var baseTitle = titleEl ? titleEl.textContent : '';
    var baseSub = subEl ? subEl.textContent : '';
    if (sortEl) sortEl.value = state.sort;

    function matches(card) {
      var ok = true;
      FILTER_KEYS.forEach(function (k) {
        if (state[k].length && state[k].indexOf(card.getAttribute('data-' + k)) < 0) ok = false;
      });
      var price = Number(card.getAttribute('data-price')) / 100;
      if (state.min && price < Number(state.min)) ok = false;
      if (state.max && price > Number(state.max)) ok = false;
      return ok;
    }

    function syncUrl() {
      /* mexe so nas chaves dos filtros; utm_*, gclid, fbclid e page continuam na URL */
      var u = new URL(location.href);
      FILTER_KEYS.concat(['min', 'max', 'gift', 'sort']).forEach(function (k) { u.searchParams.delete(k); });
      FILTER_KEYS.forEach(function (k) { if (state[k].length) u.searchParams.set(k, state[k].join(',')); });
      ['min', 'max', 'gift'].forEach(function (k) { if (state[k]) u.searchParams.set(k, state[k]); });
      if (state.sort !== 'featured') u.searchParams.set('sort', state.sort);
      if (u.href === location.href) return;
      try { history.replaceState(null, '', u); } catch (e) { }
    }

    function renderChips() {
      if (!activeEl) return;
      var out = [];
      FILTER_KEYS.forEach(function (k) {
        state[k].forEach(function (v) { out.push('<button type="button" data-chip-k="' + k + '" data-chip-v="' + esc(v) + '">' + FILTER_LABEL[k] + ': ' + esc(cap(v)) + ' &times;</button>'); });
      });
      if (state.max) out.push('<button type="button" data-chip-x="max">Under ' + money(state.max) + ' &times;</button>');
      if (state.min) out.push('<button type="button" data-chip-x="min">' + money(state.min) + ' and up &times;</button>');
      if (out.length) out.push('<button type="button" class="clr" data-chip-clear>Clear all</button>');
      activeEl.innerHTML = out.join('');
    }

    function renderTitle() {
      if (!titleEl) return;
      var picked = FILTER_KEYS.filter(function (k) { return state[k].length === 1; });
      var multi = FILTER_KEYS.filter(function (k) { return state[k].length > 0; });
      if (state.gift && !multi.length) { titleEl.textContent = 'The gift shop'; return; }
      if (state.max && !multi.length) { titleEl.textContent = 'Gifts under ' + money(state.max); return; }
      if (state.min && !multi.length) { titleEl.textContent = 'Premium gifts'; return; }
      if (multi.length === 1 && picked.length === 1) {
        var k = picked[0], v = cap(state[k][0]);
        titleEl.textContent = k === 'dial' ? v + ' dial watches' : k === 'band' ? (state[k][0] === 'leather' ? 'Leather strap watches' : 'Steel bracelet watches') : v + ' watches';
        return;
      }
      titleEl.textContent = baseTitle;
    }

    function apply() {
      /* ordenar */
      var list = cards.slice();
      if (state.sort === 'price-asc') list.sort(function (a, b) { return a.getAttribute('data-price') - b.getAttribute('data-price'); });
      else if (state.sort === 'price-desc') list.sort(function (a, b) { return b.getAttribute('data-price') - a.getAttribute('data-price'); });
      else if (state.sort === 'newest') list.sort(function (a, b) { return b.getAttribute('data-published') - a.getAttribute('data-published'); });
      else list.sort(function (a, b) { return a.getAttribute('data-index') - b.getAttribute('data-index'); });
      list.forEach(function (c) { grid.appendChild(c); });

      /* mostrar uma cor por modelo (a primeira que combina com os filtros) */
      var seen = {}, shown = 0;
      list.forEach(function (c) {
        var fam = c.getAttribute('data-family');
        var ok = matches(c) && (!fam || !seen[fam]);
        if (ok && fam) seen[fam] = true;
        c.hidden = !ok;
        if (ok) shown++;
      });
      if (countEl) countEl.textContent = shown + (shown === 1 ? ' product' : ' products');
      if (emptyEl) emptyEl.hidden = shown !== 0;
      renderChips();
      renderTitle();
      syncUrl();
      /* marca as opcoes no menu */
      $$('.fdd', root).forEach(function (dd) {
        var k = dd.getAttribute('data-k');
        var n = state[k].length;
        var btn = $('.fbtn', dd);
        if (btn) { btn.classList.toggle('on', n > 0); btn.setAttribute('data-n', n ? ' (' + n + ')' : ''); }
        $$('input', dd).forEach(function (cb) { cb.checked = state[k].indexOf(cb.value) > -1; });
      });
    }

    $$('.fdd', root).forEach(function (dd) {
      var k = dd.getAttribute('data-k');
      $('.fbtn', dd).addEventListener('click', function (e) {
        e.stopPropagation();
        var was = dd.classList.contains('open');
        closeFilters();
        if (!was) { dd.classList.add('open'); this.setAttribute('aria-expanded', 'true'); }
      });
      $$('input', dd).forEach(function (cb) {
        cb.addEventListener('change', function () {
          var i = state[k].indexOf(cb.value);
          if (cb.checked && i < 0) state[k].push(cb.value);
          if (!cb.checked && i > -1) state[k].splice(i, 1);
          apply();
        });
      });
    });

    if (sortEl) sortEl.addEventListener('change', function () { state.sort = sortEl.value; apply(); });

    if (activeEl) activeEl.addEventListener('click', function (e) {
      var b = e.target.closest('button'); if (!b) return;
      if (b.hasAttribute('data-chip-clear')) { FILTER_KEYS.forEach(function (k) { state[k] = []; }); state.min = state.max = state.gift = null; }
      else if (b.getAttribute('data-chip-x')) state[b.getAttribute('data-chip-x')] = null;
      else { var k = b.getAttribute('data-chip-k'), i = state[k].indexOf(b.getAttribute('data-chip-v')); if (i > -1) state[k].splice(i, 1); }
      apply();
    });

    apply();
  }

  /* ---------- 7. produto ---------- */
  function initProduct() {
    var root = $('[data-product]');
    if (!root || root.getAttribute('data-ready')) return;
    root.setAttribute('data-ready', '1');

    /* galeria */
    var slides = $$('[data-slide]', root);
    var thumbs = $$('[data-thumb]', root);
    var idx = 0;
    function show(i) {
      if (!slides.length) return;
      idx = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) { s.hidden = n !== idx; });
      thumbs.forEach(function (t, n) { t.setAttribute('aria-pressed', n === idx ? 'true' : 'false'); });
      /* a lupa so faz sentido quando o slide atual e uma imagem (nao video nem modelo 3D) */
      var zb = $('[data-gal-zoom]', root);
      if (zb) zb.hidden = !$('img', slides[idx]);
    }
    thumbs.forEach(function (t, n) { t.addEventListener('click', function () { show(n); }); });
    var prev = $('[data-gal-prev]', root), next = $('[data-gal-next]', root);
    if (prev) prev.addEventListener('click', function () { show(idx - 1); });
    if (next) next.addEventListener('click', function () { show(idx + 1); });
    show(0);

    /* zoom (clique na foto abre em tela cheia) */
    var main = $('[data-gal-main]', root);
    function openZoom() {
      var s = slides[idx]; var img = s && $('img', s);
      if (!img) return;
      var lb = $('.lightbox');
      if (!lb) {
        lb = document.createElement('div');
        lb.className = 'lightbox';
        lb.setAttribute('role', 'dialog');
        lb.setAttribute('aria-modal', 'true');
        lb.setAttribute('aria-label', S.zoom || 'Zoom image');
        lb.innerHTML = '<button type="button" class="ic" aria-label="Close">&times;</button><img alt="">';
        document.body.appendChild(lb);
        lb.addEventListener('click', closeLightbox);
      }
      var big = img.getAttribute('data-zoom') || img.currentSrc || img.src;
      $('img', lb).src = big;
      $('img', lb).alt = img.alt || '';
      lbOpener = document.activeElement;
      lb.classList.add('on');
      lb.setAttribute('aria-hidden', 'false');
      var closeBtn = $('button', lb); if (closeBtn) closeBtn.focus();
    }
    if (main) {
      /* clique na foto abre o zoom; o botao de lupa faz o mesmo para quem usa teclado */
      main.addEventListener('click', function (e) {
        if (e.target.closest('[data-gal-prev], [data-gal-next]')) return;
        openZoom();
      });
    }

    /* quantidade */
    var qty = $('[data-qty-input]', root);
    var qm = $('[data-qty-minus]', root), qp = $('[data-qty-plus]', root);
    if (qm && qty) qm.addEventListener('click', function () { qty.value = Math.max(1, Number(qty.value) - 1); });
    if (qp && qty) qp.addEventListener('click', function () { qty.value = Math.min(9, Number(qty.value) + 1); });

    /* gravacao: troca a variante entre "No engraving" e "Add engraving" */
    var form = $('[data-add-form]', root);
    var idInput = form && $('[name="id"]', form);
    var engBtn = $('[data-eng-toggle]', root);
    var engBox = $('[data-eng-box]', root);
    var engIn = $('[data-eng-input]', root);
    var priceEl = $('[data-price]', root);
    var addBtn = $('[data-add-btn]', root);
    var engOn = false;

    function setEngraving(on) {
      engOn = on;
      if (!engBtn || !idInput) return;
      engBtn.setAttribute('aria-expanded', on ? 'true' : 'false');
      engBtn.classList.toggle('on', on);
      if (engBox) engBox.classList.toggle('open', on);
      var vid = on ? root.getAttribute('data-variant-eng') : root.getAttribute('data-variant-base');
      if (vid) idInput.value = vid;
      if (engIn) { engIn.disabled = !on; if (on) engIn.focus(); }
      if (priceEl) priceEl.textContent = on ? priceEl.getAttribute('data-price-eng') : priceEl.getAttribute('data-price-base');
    }
    if (engBtn) engBtn.addEventListener('click', function () { setEngraving(!engOn); });
    /* o navegador pode restaurar o id oculto de uma visita anterior: volta ao estado "sem gravacao" */
    if (engBtn && idInput) setEngraving(false);

    /* entrega estimada (dias uteis, como na politica de frete) */
    function addBusinessDays(from, n) {
      var x = new Date(from);
      while (n > 0) {
        x.setDate(x.getDate() + 1);
        var w = x.getDay();
        if (w !== 0 && w !== 6) n--;
      }
      return x;
    }
    var del = $('[data-delivery]', root);
    if (del) {
      var d1 = addBusinessDays(new Date(), Number(V.deliveryMin || 5));
      var d2 = addBusinessDays(new Date(), Number(V.deliveryMax || 12));
      var fmt = function (d) { return d.toLocaleDateString(V.locale || 'en', { month: 'short', day: 'numeric' }); };
      del.textContent = fmt(d1) + ' ' + (S.to || 'to') + ' ' + fmt(d2);
    }

    /* adicionar ao carrinho */
    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (engOn && engIn && !engIn.value.trim()) { engIn.focus(); toast(S.engravingRequired); return; }
      var fd = new FormData(form);
      if (!engOn) fd.delete('properties[Engraving]');
      /* garante a variante certa: "Add engraving" so vai com texto */
      if (engBtn && idInput) {
        var vid = root.getAttribute(engOn ? 'data-variant-eng' : 'data-variant-base');
        if (vid) fd.set('id', vid);
      }
      var label = addBtn && $('[data-add-label]', addBtn);
      var old = label ? label.textContent : '';
      if (addBtn) addBtn.disabled = true;
      if (label) label.textContent = S.adding;
      addToCart(fd).then(function () {
        if (addBtn) addBtn.disabled = false;
        if (label) label.textContent = old;
      });
    });
  }

  /* ---------- 8. revelar ao rolar + cabecalho fixo ---------- */
  var io;
  function initReveal() {
    var els = $$('.rv:not(.in)');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('in'); }); return; }
    io = io || new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } });
    }, { threshold: 0.08, rootMargin: '0px 0px -30px 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  function initHeader() {
    var h = $('[data-header]');
    if (h && h.closest('.shopify-section')) h.closest('.shopify-section').classList.add('is-sticky');
  }

  /* ---------- popup de desconto ---------- */
  /* depois de assinar a newsletter (rodape ou popup) a Shopify recarrega a pagina com ?customer_posted=true */
  function initNewsletterToast() {
    if (!/[?&]customer_posted=true/.test(location.search)) return;
    try { localStorage.setItem('valtor-popup', '1'); } catch (e) { }
    if (S.newsletterSuccess) toast(S.newsletterSuccess);
  }

  function initPopup() {
    var p = $('[data-popup]');
    if (!p || p.getAttribute('data-ready') || !(V.popup && V.popup.enabled) || V.design) return;
    p.setAttribute('data-ready', '1');
    try { if (localStorage.getItem('valtor-popup')) return; } catch (e) { }
    setTimeout(function () {
      if ($('[data-overlay].open, [data-overlay].on')) return;
      openOverlay('popup');
    }, Math.max(3, Number(V.popup.delay || 14)) * 1000);
  }

  function init() {
    initHeader(); initSearch(); initTabs(); initCollection(); initProduct(); initReveal(); initNewsletterToast(); initPopup();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function () { init(); });
  document.addEventListener('shopify:section:select', function () { initReveal(); });
  setTimeout(function () { $$('.rv').forEach(function (e) { e.classList.add('in'); }); }, 3500);
})();
